import React from 'react';
import { STATUS_WORDS, STATUS_TONE } from './api.js';

export function Lighthouse({ className = 'w-7 h-7' }) {
  return (
    <svg viewBox="0 0 32 32" className={className} aria-hidden="true">
      <path d="M13 6h6l2 18H11z" fill="#0F2740" />
      <path d="M12 4h8v3h-8z" fill="#E5601F" />
      <path d="M8 26h16v2H8z" fill="#0F2740" />
      <path d="M20 7l9-3v2l-9 3z" fill="#E5601F" opacity=".8" />
      <path d="M12 7L3 4v2l9 3z" fill="#E5601F" opacity=".8" />
    </svg>
  );
}

export function Pill({ children, tone = 'bg-slate-100 text-slate-700 ring-slate-200' }) {
  return <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-semibold ring-1 ${tone}`}>{children}</span>;
}
export function StatusPill({ status }) { return <Pill tone={STATUS_TONE[status] || STATUS_TONE.draft}>{STATUS_WORDS[status] || status}</Pill>; }

export function TabBar({ value, onChange, tabs }) {
  return (
    <div className="inline-flex rounded-xl bg-slate-100 p-1 gap-0.5 flex-wrap">
      {tabs.map(([v, l, count]) => (
        <button key={v} type="button" onClick={() => onChange(v)}
          className={`px-3 py-1.5 rounded-lg text-xs font-semibold transition flex items-center gap-1.5 ${value === v ? 'bg-white text-slate-800 shadow-sm' : 'text-slate-500 hover:text-slate-700'}`}>
          {l}
          {typeof count === 'number' && count > 0 && (
            <span className={`px-1.5 py-0.5 rounded-full text-[10px] font-semibold ${value === v ? 'bg-slate-100 text-slate-700' : 'bg-slate-200/70 text-slate-500'}`}>{count}</span>
          )}
        </button>
      ))}
    </div>
  );
}

export function Card({ title, children, right, className = '' }) {
  return (
    <section className={`bg-white rounded-2xl border border-slate-200 ${className}`}>
      {(title || right) && (
        <div className="flex items-center justify-between px-5 py-3 border-b border-slate-100 gap-3 flex-wrap">
          <h3 className="text-sm font-semibold text-slate-800">{title}</h3>
          {right}
        </div>
      )}
      <div className="px-5 py-4">{children}</div>
    </section>
  );
}

export function Button({ children, onClick, kind = 'primary', disabled, type = 'button', className = '' }) {
  const base = 'px-4 py-2 rounded-xl text-sm font-semibold transition disabled:opacity-50 disabled:cursor-not-allowed';
  const styles = { primary: 'bg-orange-600 text-white hover:bg-orange-700 shadow-sm', secondary: 'bg-white text-slate-700 border border-slate-200 hover:bg-slate-50', danger: 'bg-white text-rose-700 border border-rose-200 hover:bg-rose-50', ghost: 'text-slate-600 hover:text-slate-900' };
  return <button type={type} onClick={onClick} disabled={disabled} className={`${base} ${styles[kind]} ${className}`}>{children}</button>;
}
